module.exports = __webpack_public_path__ + "static/dog-fb74e89423731421949adf62e0b0a390.jpg";